import { useStore } from "vuex";
import { ref } from "vue";
import Loader from "components/Loader/Loader";
export default {
  name: "ChatFeedbackInput",
  components: {
    Loader
  },
  props: {
    setCurrentStep: {
      type: Function,
      required: true
    }
  },
  setup(props) {
    const store = useStore();
    const isSendingFeedback = ref(undefined);
    const isClosing = ref(false)
    function getLabel(label, required = true) {
      const returnLabel = store.state.chatPanel.labels[label];
      if (!returnLabel && required) console.error("Label does not exist", label);
      return !returnLabel && required ? `[${label}]` : returnLabel;
    }

    async function sendConversationFeedback(payload) {
      const { feedback } = payload;
      if (feedback === "positive") {
        try {
          isSendingFeedback.value = "positive";
          await store.dispatch("chatPanel/sendConversationFeedback", {
            feedback: {
              feedback: feedback,
            }
          });
        } finally {
          isSendingFeedback.value = undefined;
          props.setCurrentStep('ChatFeedbackReview')
        }
      } else if (feedback === "negative") {
        try {
          isSendingFeedback.value = "negative";
          await store.dispatch("chatPanel/sendConversationFeedback", {
            feedback: {
              feedback: feedback,
            }
          });
        } finally {
          isSendingFeedback.value = undefined;
          props.setCurrentStep('ChatFeedbackPhoneNumber')
        }
      }
    }

    async function closeFeedback() {
      isClosing.value = true
      await store.dispatch("chatPanel/endConversation");
      isClosing.value = false
    }

    return {
      isSendingFeedback,
      isClosing,
      closeFeedback,
      sendConversationFeedback,
      getLabel,
    };
  },
};
